import { HttpHeaders } from '@angular/common/http';
import { List } from 'linqts';



  
  export const httpOptionsDefault = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
    })
  };


  //export const IMAGE_MM_TO_PIXELS_FACTOR =  4.140243902439024;// 4.18666666666;

  export const APP_VERSION = require('../../../../package.json').version;

 export const DEBUG_ENVIRONMENT = (window.location.href.indexOf("localhost") > -1) || (window.location.href.indexOf("192.168.77.140") > -1) ;

 export const CURRENT_DATABASE = "MongoDb";


 export const API_ADDRESS_INTERNET =  'https://www.sploto.net/SPLotoWebApi/api';

  export const API_ADDRESS_LOCAL =  'http://192.168.77.200:15629/api';

export const API_ADDRESS_DEBUG= 'http://192.168.77.200:15629/api'; //server local
// export const API_ADDRESS_LOCAL =  'http://localhost:15629/api';

//  export const API_ADDRESS_DEBUG= 'http://localhost:15629/api'; //server local
 
 export const firebaseCredentials =  "";

 export const PAYMENT_ADDRESS =  'https://www.spolti.com.br/ore/checkout';

 export const PARAMETERS_TAB_INDEX= 1;
 export const CARD_TAB_INDEX= 0;
 export const FILTER_TAB_INDEX= 2;
 export const PRINT_TAB_INDEX= 4;
 export const CONFERENCE_TAB_INDEX= 3;


 export class UfList
{
    public static getUfs():List<any>
    {

        return  new List(
            [
              { name: "Paraná - PR", id: "PR" },
              { name: "São Paulo - SP", id: "SP" },
              { name: "Rio de Janeiro - RJ", id: "RJ" },
              { name: "Minas Gerais - MG", id: "MG" },
              { name: "Santa Catarina - SC", id: "SC" },
              { name: "Rio Grande do Sul - RS", id: "RS" },




              
            ]);

            
    }
}
